export interface TaxConstructor {
  id: number
  description: string
  isActive: boolean
  isDefault: boolean
  isInclusive: boolean
  name: string
  percentage: string
}

export class Tax {
  id: number
  description: string
  isActive: boolean
  isDefault: boolean
  isInclusive: boolean
  name: string
  percentage: string

  constructor(data: TaxConstructor) {
    this.id = data.id
    this.description = data.description
    this.isActive = data.isActive
    this.isDefault = data.isDefault
    this.isInclusive = data.isInclusive
    this.name = data.name
    this.percentage = data.percentage
  }
}
